<template>
  <div class="app-wrapper">
    <div class="header-wrapper">
      <img src="../assets/Home/header.png" alt="" class="header-img">
      <div class="header-title">
        <div>守护生命之源</div>
        <div>三溪浦水库</div>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="title-wrapper">
        <div class="md-title">认&nbsp;&nbsp;识&nbsp;&nbsp;三&nbsp;&nbsp;溪&nbsp;&nbsp;浦</div>
        <img src="../assets/Home/long-bl.png" alt="" class="bl">
      </div>
      <!-- 头部介绍视频   -->
      <div class="video-wrapper">
        <div v-show="!showTopVideo" @click="openTopVideo">
          <img class="video top-video" :src="lb3" alt="">
          <img :src="bfBtn" alt="" class="top-bf-btn">
        </div>
        <video v-show="showTopVideo" @ended="handleTopVideoEnded" ref="topVideo" class="video" playsinline preload="auto" controls>
          <source :src="videoSrc" type="video/mp4">
        </video>
      </div>

      <div class="title-wrapper title-wrapper-two">
        <div class="md-title">动画剧场&nbsp;&nbsp;•&nbsp;&nbsp;溪宝的奇妙世界</div>
        <img src="../assets/Home/short-bl.png" alt="" class="bl-s">
      </div>
      <!-- 动画视频   -->
      <!--      <div class="video-wrapper">-->
      <!--        <div class="am-wrapper" v-for="(item, index) in amArr" :key="index">-->
      <!--          <img-->
      <!--              :src="item.bgSrc"-->
      <!--              alt=""-->
      <!--              class="am-img-bg"-->
      <!--              @click="openFullScreen(index)"-->
      <!--          >-->
      <!--          <img :src="bfBtn" alt="" class="bf-btn" @click="openFullScreen(index)">-->
      <!--          <video-->
      <!--              :ref="el => videoRefs[index] = el"-->
      <!--              class="video-s"-->
      <!--              controls-->
      <!--              playsinline-->
      <!--              preload="metadata"-->
      <!--          >-->
      <!--            <source :src="item.src" type="video/mp4">-->
      <!--          </video>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="video-wrapper">
        <div class="am-wrapper" v-for="(item, index) in amArr" :key="index">
          <!-- 添加触摸事件处理移动端点击 -->
          <div class="video-click-area" @click="handleVideoClick(index)">
            <img :src="item.bgSrc" alt="" class="am-img-bg">
            <img :src="bfBtn" alt="" ref="bfBtn" class="bf-btn">
          </div>
          <video
              :ref="el => videoRefs[index] = el"
              class="video-s"
              :controls="shouldShowControls"
              playsinline
              webkit-playsinline
              x5-playsinline
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portrait"
              preload="auto"
              @click="handleVideoClick(index)"
              @ended="handleVideoEnded(index)"
          >
            <source :src="item.src" type="video/mp4">
            您的浏览器不支持视频标签。
          </video>
        </div>
      </div>
      <!--   轮播图以及文字简介   -->
      <div class="lb-wrapper">
        <swiper ref="mySwiper" class="swiper" :options="options" >
          <swiper-slide>
            <img :src="lb1" alt="" class="swp-img">
          </swiper-slide>
          <swiper-slide>
            <img :src="lb2" alt="" class="swp-img">
          </swiper-slide>
          <swiper-slide>
            <img :src="lb3" alt="" class="swp-img">
          </swiper-slide>
        </swiper>
        <div class="text-wrapper">
          <div class="label-wrapper">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三溪浦水库位于宁波市鄞州区东吴镇境内，与东南佛国之称的天童寺、舍利宝刹阿育王寺相毗邻。水库汇合天童、凤下、画龙三溪之水，山清水秀，风光旖旎，与有着西湖风光、太湖气魄的东钱湖遥相辉映，如神手连百里太白，映平湖诗画天成，人称“太白湖”。</div>
          <div class="label-wrapper">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三溪之水于此汇聚、中转，儒、道、释三教文化于此荟聚、传播，掠过的是历史，连接的是一个水库的过去与未来。</div>
        </div>
      </div>
    </div>

    <div class="bottom-wrapper">
      <img :src="bottom1" alt="" class="header-img">
    </div>

    <!--  底部按钮组  -->
    <div class="btn-group">
      <div class="btn-item">
        <span class="btn-text">首 页</span>
      </div>
      <div class="btn-item">
        <span class="btn-text">科普问答</span>
      </div>
      <div class="btn-item">
        <span class="btn-text" @click="toPage">关于我们</span>
      </div>
    </div>
  </div>
</template>

<script>
import videoSrc from '../assets/Video/jieshao.mp4';
import am1 from '../assets/Video/am1.mp4';
import am2 from '../assets/Video/am2.mp4';
import am3 from '../assets/Video/am3.mp4';
import am1Bg from '../assets/Home/am1-bg.png';
import am2Bg from '../assets/Home/am2-bg.png';
import am3Bg from '../assets/Home/am3-bg.png';
import lb1 from '../assets/Home/lb1.jpg'
import lb2 from '../assets/Home/lb2.jpg'
import lb3 from '../assets/Home/lb3.jpg'
import bottom1 from '../assets/Home/bottom1.png';
import bfBtn from '../assets/Home/bfBtn.png';
export default {
  name: "HOME",
  data() {
    return {
      videoSrc,
      am1,
      am2,
      am3,
      am1Bg,
      am2Bg,
      am3Bg,
      lb1,
      lb2,
      lb3,
      bottom1,
      bfBtn,
      showTopVideo: false,
      amArr: [
        { bgSrc: am1Bg, src: am1 } ,
        { bgSrc: am2Bg, src: am2 },
        { bgSrc: am3Bg, src: am3 }
      ],
      // 用于存储视频DOM元素的引用
      videoRefs: [],
      isFullscreen: false,
      currentVideoIndex: null,
      shouldShowControls: false, // 控制是否显示原生控制器
      touchStartTime: 0,
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
      isAndroid: /Android/.test(navigator.userAgent),
      options: {
        loop: true,
        autoplay: {
          //swiper手动滑动之后自动轮播失效的解决方法,包括触碰，拖动，点击pagination,重新启动自动播放
          disableOnInteraction: false,
          // 自动播放时间：毫秒
          delay: 2000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    }
  },
  mounted() {
    this.videoRefs = [];
    this.initVideoElements();
    this.detectPlatform();
  },
  beforeDestroy() {
    this.removeEventListeners();
  },
  methods: {
    openTopVideo() {
      // 1. 显示视频
      this.showTopVideo = true;

      // 2. 等待DOM更新
      this.$nextTick(() => {
        const videoElement = this.$refs.topVideo;

        if (videoElement) {
          // 3. 重置播放位置
          videoElement.currentTime = 0;

          // 4. 播放视频
          const playPromise = videoElement.play();

          // 5. 处理自动播放被阻止的情况
          if (playPromise !== undefined) {
            playPromise.catch(() => {
              console.log('自动播放被阻止，用户可能需要手动点击播放');
              // 这里可以显示提示信息或播放按钮
            });
          }
        }
      });
    },
    // 视频播放结束处理
    handleTopVideoEnded() {
      // 隐藏视频，显示图片
      this.showTopVideo = false;

      // 重置视频播放位置
      const videoElement = this.$refs.topVideo;
      if (videoElement) {
        videoElement.currentTime = 0;
      }
    },
    detectPlatform() {
      console.log('检测到平台:', this.isIOS ? 'iOS' : this.isAndroid ? 'Android' : '其他');
    },

    // 初始化视频元素
    initVideoElements() {
      this.$nextTick(() => {
        this.videoRefs.forEach((video) => {
          if (video) {
            // 设置视频属性
            video.setAttribute('webkit-playsinline', 'true');
            video.setAttribute('playsinline', 'true');
            video.setAttribute('x5-playsinline', 'true');
            video.setAttribute('x5-video-player-type', 'h5');
            video.setAttribute('x5-video-player-fullscreen', 'true');

            // 初始隐藏视频
            video.style.display = 'none';
            video.style.height = '0';
          }
        });
      });
    },

    // 处理点击事件
    handleVideoClick(index) {
      // 停止顶部视频
      const topVideo = this.$refs.topVideo;
      console.log('topVideo', topVideo);
      if (topVideo) {
        topVideo.pause();
      }
      this.currentVideoIndex = index;
      this.openFullScreen(index);
    },

    // 打开全屏播放视频
    async openFullScreen(index) {
      const videoElement = this.videoRefs[index];

      if (!videoElement) {
        console.error('视频元素未找到');
        return;
      }


      // 先显示视频元素
      videoElement.style.display = 'block';
      videoElement.controls = true;
      videoElement.style.zIndex = '1000';
      videoElement.style.opacity = '0';

      videoElement.setAttribute('controls', 'controls');

      // 确保视频已加载
      videoElement.load();

      await new Promise(resolve => setTimeout(resolve, 300));
      try {
        // 不同平台的策略
        if (this.isIOS) {
          await this.handleIOSFullScreen(videoElement, index);
        } else if (this.isAndroid) {
          await this.handleAndroidFullScreen(videoElement, index);
        } else {
          await this.handleOtherFullScreen(videoElement, index);
        }

        // 设置显示控制器
        this.shouldShowControls = true;

        // 添加全屏事件监听
        this.addFullscreenListeners(videoElement, index);

      } catch (error) {
        console.error('全屏播放失败:', error);
        // 如果全屏失败，至少尝试播放视频
        this.fallbackPlay(videoElement);
      }
      // setTimeout(async() => {
      //   try {
      //     // 不同平台的策略
      //     if (this.isIOS) {
      //       await this.handleIOSFullScreen(videoElement, index);
      //     } else if (this.isAndroid) {
      //       await this.handleAndroidFullScreen(videoElement, index);
      //     } else {
      //       await this.handleOtherFullScreen(videoElement, index);
      //     }
      //
      //     // 设置显示控制器
      //     this.shouldShowControls = true;
      //
      //     // 添加全屏事件监听
      //     this.addFullscreenListeners(videoElement, index);
      //
      //   } catch (error) {
      //     console.error('全屏播放失败:', error);
      //     // 如果全屏失败，至少尝试播放视频
      //     this.fallbackPlay(videoElement);
      //   }
      // }, 300)
    },

    // 处理iOS全屏
    async handleIOSFullScreen(videoElement) {
      console.log('iOS设备，使用特殊处理');

      // iOS需要先播放再进入全屏
      try {
        // 尝试播放
        await videoElement.play();

        // iOS Safari需要使用webkitEnterFullscreen
        if (videoElement.webkitEnterFullscreen) {
          videoElement.webkitEnterFullscreen();
        } else if (videoElement.webkitRequestFullscreen) {
          videoElement.webkitRequestFullscreen();
        }

        // 确保控制器显示
        videoElement.controls = true;

      } catch (playError) {
        console.log('iOS自动播放被阻止，等待用户交互');
        // iOS自动播放可能被阻止，等待用户点击播放按钮
        videoElement.controls = true;
      }
    },

    // 处理Android全屏
    async handleAndroidFullScreen(videoElement) {
      console.log('Android设备，使用特殊处理');

      // Android通常可以尝试直接全屏
      try {
        // 先尝试进入全屏
        if (videoElement.requestFullscreen) {
          await videoElement.requestFullscreen();
        } else if (videoElement.mozRequestFullScreen) {
          await videoElement.mozRequestFullScreen();
        } else if (videoElement.webkitRequestFullscreen) {
          await videoElement.webkitRequestFullscreen();
        } else if (videoElement.msRequestFullscreen) {
          await videoElement.msRequestFullscreen();
        }

        // 然后播放视频
        // await videoElement.play();
        // 播放视频*/
        const playPromise = videoElement.play();
        // 确保控制器显示
        videoElement.controls = true;

        // 处理可能出现的自动播放阻止*/
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log("自动播放被阻止，需要用户交互", error);
            // 可以在这里添加用户交互提示*/
          });
        }

        // 监听全屏变化事件，当退出全屏时暂停视频*/
        const fullscreenChange = () => {
          if (!document.fullscreenElement &&
              !document.webkitFullscreenElement) {
            // 退出全屏时隐藏视频*/
            videoElement.style.display = 'none';
            videoElement.pause();
            document.removeEventListener('fullscreenchange', fullscreenChange);
            document.removeEventListener('webkitfullscreenchange', fullscreenChange);
            document.removeEventListener('mozfullscreenchange', fullscreenChange);
            document.removeEventListener('MSFullscreenChange', fullscreenChange);
          }
        };

        document.addEventListener('fullscreenchange', fullscreenChange);
        document.addEventListener('webkitfullscreenchange', fullscreenChange);
        document.addEventListener('mozfullscreenchange', fullscreenChange);
        document.addEventListener('MSFullscreenChange', fullscreenChange);
        // 监听视频播放结束，退出全屏*/
        videoElement.addEventListener('ended', () => {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        });

      } catch (error) {
        console.log('Android全屏失败，尝试其他方法:', error);
        // 如果全屏失败，尝试播放并手动控制
        await videoElement.play();
      }
    },

    // 处理其他平台
    async handleOtherFullScreen(videoElement) {
      // 尝试标准全屏API
      if (videoElement.requestFullscreen) {
        await videoElement.requestFullscreen();
      } else if (videoElement.webkitRequestFullscreen) {
        await videoElement.webkitRequestFullscreen();
      } else if (videoElement.mozRequestFullScreen) {
        await videoElement.mozRequestFullScreen();
      } else if (videoElement.msRequestFullscreen) {
        await videoElement.msRequestFullscreen();
      }

      // 播放视频
      await videoElement.play();
      videoElement.controls = true;
    },

    // 添加全屏事件监听
    addFullscreenListeners(videoElement, index) {
      // 退出全屏时的事件处理
      const handleFullscreenChange = () => {
        if (!document.fullscreenElement &&
            !document.webkitFullscreenElement &&
            !document.mozFullScreenElement &&
            !document.msFullscreenElement) {
          // 退出全屏
          this.handleExitFullscreen(videoElement, index);
        }
      };

      // 保存事件处理函数引用，便于移除
      videoElement._fullscreenHandler = handleFullscreenChange;

      // 监听全屏变化事件
      document.addEventListener('fullscreenchange', handleFullscreenChange);
      document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.addEventListener('mozfullscreenchange', handleFullscreenChange);
      document.addEventListener('MSFullscreenChange', handleFullscreenChange);

      // 监听视频点击事件，确保控制器显示
      videoElement.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    },

    // 处理退出全屏
    handleExitFullscreen(videoElement) {
      // 隐藏视频
      videoElement.style.display = 'none';
      videoElement.style.zIndex = 'auto';

      // 暂停视频并重置播放位置
      videoElement.pause();
      videoElement.currentTime = 0;

      // 移除全屏监听
      this.removeFullscreenListeners(videoElement);

      // 重置状态
      this.shouldShowControls = false;
      this.currentVideoIndex = null;
      this.isFullscreen = false;
    },

    // 处理视频播放结束
    handleVideoEnded(index) {
      const videoElement = this.videoRefs[index];
      if (videoElement) {
        // 视频播放结束，退出全屏
        this.exitFullscreen();
      }
    },

    // 退出全屏
    exitFullscreen() {
      const exitMethods = [
        document.exitFullscreen,
        document.webkitExitFullscreen,
        document.mozCancelFullScreen,
        document.msExitFullscreen
      ];

      for (const method of exitMethods) {
        if (method && method.call(document)) {
          return true;
        }
      }
      return false;
    },

    // 移除全屏监听
    removeFullscreenListeners(videoElement) {
      if (videoElement._fullscreenHandler) {
        document.removeEventListener('fullscreenchange', videoElement._fullscreenHandler);
        document.removeEventListener('webkitfullscreenchange', videoElement._fullscreenHandler);
        document.removeEventListener('mozfullscreenchange', videoElement._fullscreenHandler);
        document.removeEventListener('MSFullscreenChange', videoElement._fullscreenHandler);
        delete videoElement._fullscreenHandler;
      }
    },

// 加强事件监听器清理
    removeEventListeners() {
      // 清理每个视频元素
      this.videoRefs.forEach((video, index) => {
        if (video) {
          // 移除所有自定义事件监听器
          this.removeFullscreenListeners(video);

          // 停止播放并重置
          video.pause();
          video.currentTime = 0;

          // 清理所有事件监听器
          const clone = video.cloneNode(true);
          video.parentNode.replaceChild(clone, video);
          this.videoRefs[index] = clone;
        }
      });

      // 清理顶部视频
      const topVideo = this.$refs.topVideo;
      if (topVideo) {
        topVideo.pause();
        topVideo.currentTime = 0;
      }

      // 移除文档级别的全屏监听
      document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
    },

    // 回退方案：如果全屏失败，至少播放视频
    fallbackPlay(videoElement) {
      videoElement.style.display = 'block';
      videoElement.controls = true;

      videoElement.play().catch(error => {
        console.log('回退播放失败:', error);
        // 显示播放按钮让用户手动点击
      });
    },

    toPage() {
      this.$router.push({
        path: '/About'
      })
    }
  }
}
</script>

<style scoped>
.app-wrapper {
  position: relative;
  width: 100vw;
  min-height: 100vh; /* 确保容器至少有一屏高度 */
  overflow: visible; /* 允许内容溢出 */
  /*background-color: #c5ecfd;*/
  /*background:url('../assets/Home/bk.png');*/
  background: linear-gradient(180deg, #b9e3ff, #d9f1ff);
  background-size: cover;
}
.header-img {
  width: 100vw;
}
.header-wrapper {
  position: relative;
}
.header-title {
  position: absolute;
  top: 124px;
  right: 55px;
  font-size: 26px;
  font-weight: 800;
  color: white;
}
.content-wrapper {
  position: relative;
  z-index: 2; /* 确保内容在图片上层 */
  padding: 0 24px;
}
.title-wrapper {
  display: flex;
  align-items: center;
  padding: 8px;
}
.title-wrapper-two {
  padding: 12px 8px;
}
.bl {
  width: 40%;
  margin-left: 10px;
}
.bl-s {
  width: 20%;
  margin-left: 10px;
}
.md-title {
  font-size: 18px;
  font-weight: 600;
  color: #457fb3;
}
.video-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.video {
  width: 100%;
  border-radius: 12px;
}
.top-video {
  position: relative;
}
.top-bf-btn {
  position: absolute;
  right: 5px;
  bottom: 5px;
  transform: scale(0.8);
  opacity: 0.7;
}
.video-s {
  /*display: none; !* 初始隐藏视频元素 *!*/
  width: 30%;
  /*object-fit: cover;*/
  border-radius: 12px;
}
.am-wrapper {
  position: relative;
  width: 30%;
  border-radius: 12px;
}
.bf-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.8);
  opacity: 0.7;
}
.am-img-bg {
  width: 100%;
  order-radius: 12px;
  height: auto;
  display: block;
  cursor: pointer;
  /* 添加点击反馈效果 */
  transition: opacity 0.3s ease;
}
.am-img-bg:active {
  opacity: 0.8;
}
/* 全屏状态下的样式调整 */
:fullscreen .video-s,
:-webkit-full-screen .video-s,
:-moz-full-screen .video-s,
:-ms-fullscreen .video-s {
  display: block !important;
  width: 100vw !important;
  height: 100vh !important;
  object-fit: contain;
  background-color: #000;
}

/* 强制显示媒体控制条 */
:fullscreen .video-s::-webkit-media-controls,
:-webkit-full-screen .video-s::-webkit-media-controls {
  display: flex !important;
  visibility: visible !important;
}

:fullscreen .video-s::-webkit-media-controls-panel,
:-webkit-full-screen .video-s::-webkit-media-controls-panel {
  display: flex !important;
  visibility: visible !important;
}

/* 确保控制条可见 */
.video-s::-webkit-media-controls {
  visibility: visible !important;
  opacity: 1 !important;
}
.lb-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.swiper {
  flex: 4;
}
.text-wrapper {
  flex: 5;
  margin-left: 24px;
  font-size: 10px;
}
.swp-img {
  width: 100%;
  object-fit: cover;
  border-radius: 12px;
}
.bottom-wrapper {
  /*position: absolute;*/
  /*bottom: -152px;*/
  /*left: 0;*/
  z-index: 1; /* 图片在内容下面 */
}
.btn-group {
  display: flex;
  justify-content: space-between;
  position: fixed;
  padding: 0 24px;
  bottom: 10px;
  left: 0;
  width: calc(100% - 48px);
  z-index: 3;
}
.btn-item {
  width: 110px;
  height: 30px;
  line-height: 30px;
  background-color: #ffffff;
  text-align: center;
  border-radius: 4px;
  font-weight: 800;
  font-size: 20px;
  box-shadow: 0px 15px 15px 0px rgba(0, 0, 0, 0.2);
}
.btn-text {
  background-image: linear-gradient(to right , #7db7d9, #7ab3d6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>